module.exports = __webpack_public_path__ + "img/5.9923eebf.png";